module.exports = __webpack_public_path__ + "static/media/liked2.cebd5d91.svg";